import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import type { ReduxState } from 'app/redux/types';

import { UnionsMenu } from '../../../components/UnionsMenu';
import { unionsMenuLayersByPathname } from '../../../selectors/prematch';
export const PrematchUnionsMenuLayer = () => {
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  const timeFilter = params.get('timeFilter');

  const unionsMenuItems = useSelector(
    (state: ReduxState) => unionsMenuLayersByPathname(state, pathname, timeFilter));

  return (
    <>
      {unionsMenuItems && (
        <UnionsMenu list={unionsMenuItems} />
      )}
    </>
  );
};
